
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, UserPlus } from 'lucide-react';

const MasterDataTab = () => {
  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <UserPlus className="h-5 w-5 text-primary" />
              Entities Management
            </CardTitle>
            <CardDescription>Manage corporate entities and their details</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Total Entities:</span>
                <Badge variant="outline">3</Badge>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Last Updated:</span>
                <span className="text-sm">2025-04-28</span>
              </div>
              <Button className="w-full mt-4">
                <UserPlus className="mr-2 h-4 w-4" />
                Add New Entity
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <UserPlus className="h-5 w-5 text-primary" />
              Directors & KMP
            </CardTitle>
            <CardDescription>Manage directors, committees and key managerial personnel</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Directors:</span>
                <Badge variant="outline">8</Badge>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">KMPs:</span>
                <Badge variant="outline">5</Badge>
              </div>
              <Button className="w-full mt-4">
                <UserPlus className="mr-2 h-4 w-4" />
                Add New Member
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <UserPlus className="h-5 w-5 text-primary" />
              Committees
            </CardTitle>
            <CardDescription>Manage board committees and their members</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Total Committees:</span>
                <Badge variant="outline">6</Badge>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Last Updated:</span>
                <span className="text-sm">2025-05-01</span>
              </div>
              <Button className="w-full mt-4">
                <FileText className="mr-2 h-4 w-4" />
                Manage Committees
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <UserPlus className="h-5 w-5 text-primary" />
              Auditors
            </CardTitle>
            <CardDescription>Manage statutory and internal auditors</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Statutory Auditors:</span>
                <Badge variant="outline">1</Badge>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Internal Auditors:</span>
                <Badge variant="outline">2</Badge>
              </div>
              <Button className="w-full mt-4">
                <FileText className="mr-2 h-4 w-4" />
                Manage Auditors
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Upload e-Forms for Data Import</CardTitle>
          <CardDescription>
            Bulk import entity, director and other data from regulatory e-Forms
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="grid gap-4 md:grid-cols-3">
              <div className="border rounded-md p-4 text-center">
                <FileText className="h-8 w-8 mx-auto mb-2 text-primary" />
                <p className="font-medium">DIR-12</p>
                <p className="text-xs text-muted-foreground mb-4">For director appointments</p>
                <Button variant="outline" size="sm">Upload</Button>
              </div>
              <div className="border rounded-md p-4 text-center">
                <FileText className="h-8 w-8 mx-auto mb-2 text-primary" />
                <p className="font-medium">MGT-7</p>
                <p className="text-xs text-muted-foreground mb-4">For annual returns</p>
                <Button variant="outline" size="sm">Upload</Button>
              </div>
              <div className="border rounded-md p-4 text-center">
                <FileText className="h-8 w-8 mx-auto mb-2 text-primary" />
                <p className="font-medium">PAS-3</p>
                <p className="text-xs text-muted-foreground mb-4">For allotments</p>
                <Button variant="outline" size="sm">Upload</Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default MasterDataTab;
